import * as API from './'

export default {

  /*登录接口*/
  get_login_auth:params =>{
    // return API.POST(BASEURL+ '/api/v1/login', params)
    return API.POST(ACCOUNTSERVER+'/api/auth/login', params)
  },

  get_user_detail: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/detail/token', params)
  },

  get_user_dept: param => {
    return API.POST(ACCOUNTSERVER + "/api/v1/user/znf/dept/list", param);
  },

  /*获取登录验证码*/
  getCode:params =>{
    return API.GET(BASEURL + '/api/v1/getCaptchaBase64', params)
  },

  //获取业务区划
  deptuserArea: params => {
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/get/user/area', params)
  },
  //修改密码
  changePassword: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/changePassword', params)
  },
/*
  /!*获取数据中台token*!/
  get_zt_token: params => {
    return API.POST(BUSISERVER + '/api/v1/token/gettoken', params)
  },
*/



}



// WEBPACK FOOTER //
// ./src/api/api_sys_manage.js